import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { IconTile } from '@atlaskit/icon';
import PageIcon from '@atlaskit/icon/core/page';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlaskit/primitives/compiled';

import { usePageSpaceKey } from '@confluence/page-context';

import { buildCreationLink } from '../CreateContentRouteComponent/createContentRouteUtils.ts';

import { ContentTreeOnboardingItem, SOURCE_NAME } from './ContentTreeOnboardingItem.tsx';

export const CreatePageOnboardingItem = () => {
	const [spaceKey] = usePageSpaceKey();

	const createPageLink = buildCreationLink({
		contentType: 'page',
		source: SOURCE_NAME,
		spaceKey,
	});

	return (
		<ContentTreeOnboardingItem
			href={createPageLink}
			iconGlyph={
				<IconTile
					icon={() => <PageIcon label="" color={token('color.text.inverse')} />}
					appearance="blueBold"
					label=""
					size="24"
				/>
			}
			contentType="page"
		>
			<Text maxLines={1} color="color.text.subtle">
				<FormattedMessage {...i18n.addYourFirstPage} />
			</Text>
		</ContentTreeOnboardingItem>
	);
};

const i18n = defineMessages({
	addYourFirstPage: {
		id: 'create-blank-fabric-page.content-tree-onboarding.new-page',
		defaultMessage: 'Add your first page',
		description: 'Text shown in empty content tree which prompts user to create a new page.',
	},
});
